// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/SessionDetails/sessionDetail.css
// module id = 833
// module chunks = 1